import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import Field from "../../../components/Fields/Field";
import FieldLabel from "../../../components/Fields/FieldLabel";
import SelectListField from "../../../components/Fields/SelectListField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import UserDefinedField from "../../../components/Fields/UserDefinedField";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ProductCategoryModel from "../../../models/ProductCategoryModel";
import UserDefinedFieldValueModel from "../../../models/UserDefinedFieldValueModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

const AddSizePopup: React.FC<PopupProps> = ({ show, onHide }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const navigate = useNavigate()

    const [formData, setFormData] = useState<ProductCategoryModel>({
        id: 0,
        name: '',
        abbreviation: '',
        itemTypeId: 0,
        parentProductCategoryId: 0,
        beginDate: new FormatUtils().formatDateForStorage(new Date()),
        endDate: '',
        concurrencyId: '',
        userDefinedFields: [],
    });

    const productCategories = useSelectListOptions('api/v1/selectlist/ProductCategoryNameTrees?activeObly=true', '-- Select category');
    const itemTypes = useSelectListOptions('api/v1/selectlist/ItemTypes?activeOnly=true', '-- Select itemtype');

    useEffect(() => {
            DataService.get<UserDefinedFieldValueModel[]>('api/v1/productcategoryuserdefinedfields/fornewproductcategory/')
                .then(response => {
                    formData.userDefinedFields = [...response];
                    setFormData({ ...formData });
                })
                .catch(e => handleException(e));
    }, []);

    function submit() {
        if (formData) {
                DataService
                    .create<ProductCategoryModel>(`api/v1/productcategories/`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true && response.data)
                            navigate('/plm/itemsetup/productcategory/' + response.data);
                    })
                    .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'abbreviation', label: 'Abbreviation', labelSize: 3 },
            { name: 'itemTypeId', label: 'Item type', labelSize: 3 },
            { name: 'parentProductCategoryId', label: 'Parent product category', labelSize: 3 },
            { name: 'beginDate', label: 'Active from', labelSize: 3, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    if (formData && formData.userDefinedFields) {
        formData.userDefinedFields.forEach((value, index) => {
            let label = value.userDefinedField.name
            formConfig.fields.push({ name: 'userDefinedFields.' + index + '.value', label: label, labelSize: 3 });
        });
    }

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Product Category'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <TextboxField {...getFieldProps('abbreviation')} />
                <SelectListField {...getFieldProps('itemTypeId')} options={itemTypes} />
                <SelectListField {...getFieldProps('parentProductCategoryId')} options={productCategories} />
                {formData && formData.userDefinedFields &&
                    formData.userDefinedFields.map((value, index) => {
                        let name = 'userDefinedFields.' + index + '.value';
                        return (<UserDefinedField {...getFieldProps(name)} userDefinedFieldValue={value} key={'userDefinedField' + index} />);
                    })
                }
                <Field {...getLabelProps('beginDate')}>
                    <DateControl {...getControlProps('beginDate')} />
                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                    <DateControl {...getControlProps('endDate')} />
                </Field>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddSizePopup;